export class Controller {
    /** @ngInject */
    constructor(
        $state,
        $timeout,
        Alert,
        PasswordManagers,
    ) {
        this.$state=$state;
        this.Alert = Alert;
        this.$timeout=$timeout;
        this.PasswordManagers=PasswordManagers;
    }
    $onInit()  {
        this.fileType=null;
        this.importResult=null;
        this.fileToUpload = { value: null };
        this.isUploading=false;
        this.uploadCSV = () => {
            
            if(!this.fileToUpload.value) {
                return;
            }
            this.isUploading=true;
            this.PasswordManagers.importItems(this.fileType,  this.fileToUpload.value,
                (data) => {
                    this.isUploading=false;
                if(data.numberOfFailedImport==0) {
                    this.$state.go('user.public.user-accounts', {}, {reload: true});
                    this.Alert('success', 'password-managers-import.result.success');
                } else {
                    this.$state.go('user.public.user-accounts.import.result', {importResult: data});
                }
                    
                }, (response, status) => {
                    this.isUploading=false;
                    this.fileToUpload.value=null;
                    document.getElementById("uploadInput").value=null;
                    this.importResult=null;
                    
                });
            
        }; 
        this.fnc = () =>{
            this.$timeout(() =>{ document.getElementById("uploadInput").click(); });                    
        };
    }
    
}


// WEBPACK FOOTER //
// ./src/portal/states/user/public-user-accounts/import/import.controller.js